import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UserAuthService } from '../../services/user-auth.service';
import { ManagerialOperationsService, LoggedInUser } from '../../services/managerial-operations.service';
import { CurrentUser, OrganisationUser } from '../../models/auth-user';

// Shown when a logged-in user has NO visible menu — i.e. the admin has disabled
// every menu group the user's role had access to. They are authenticated but
// there is nowhere in the app for them to land, so we explain that and offer a
// way back to login instead of bouncing them around guarded routes.
@Component({
  selector: 'fcsro-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.css']
})
export class NoAccessComponent {

  constructor(
    private authSer: AuthenticationService,
    private uauthSer: UserAuthService,
    private managerSer: ManagerialOperationsService,
    private router: Router
  ) { }

  logout() {
    this.authSer.getCurretUser().subscribe(
      (user) => {
        if (user instanceof CurrentUser) {
          this.uauthSer.logOut(user.UserDetails.id);
        } else if (user instanceof LoggedInUser) {
          this.managerSer.logOut(user.id);
        } else if (user instanceof OrganisationUser) {
          this.uauthSer.logOut(user.id);
        } else {
          this.router.navigateByUrl('/auth/login');
        }
      },
      () => this.router.navigateByUrl('/auth/login')
    );
  }
}
